var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$i18n.locale != 'ar')?_c('button',{on:{"click":function($event){return _vm.SetLocale('ar')}}},[_vm._v(" العربية ")]):_c('button',{on:{"click":function($event){return _vm.SetLocale('en')}}},[_vm._v("English")])])
}
var staticRenderFns = []

export { render, staticRenderFns }